// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"157c393c","387":"db561790","593":"ee792e17","681":"d4dc3f22","702":"da39a8b5","895":"157c393c"}[chunkId] + ".chunk.css";
};